import type { RouterIdsVO } from "@/api"
import { useControllerModel } from "@/models"
import { getCurrentPageType } from "@/util/commonUtils"
import { LeftOutlined, RightOutlined } from "@ant-design/icons"
import { useCreation } from "ahooks"
import { Button } from "antd"
import classNames from "classnames"
import type { FC } from "react"
import { useCallback, useEffect } from "react"
import "./index.scss"
// ==============================================
// controller隐藏列表
const controllerHiddenList = ["marketing", "competitor", "region-insight"]
// ==============================================
interface FloatingControllerButtonProps {
  params: RouterIdsVO
}
const FloatingControllerButton: FC<FloatingControllerButtonProps> = ({ params }) => {
  const { brandId, cityId } = params
  const { isAllShow, toggleAllShow } = useControllerModel()
  const type = getCurrentPageType()

  // 显隐开关是否显示
  const isControllerShow = useCreation(() => {
    return controllerHiddenList?.indexOf(type as any) < 0
  }, [cityId, brandId, type])

  // 页面内容是否显示
  const handleClick = useCallback(() => {
    toggleAllShow(!isAllShow)
  }, [isAllShow, toggleAllShow])

  // 控制地图缩放控件位置
  useEffect(() => {
    const element = document.querySelector(".navigation-control")

    if (element) {
      if (isAllShow) {
        element.classList.remove("navigation-control-right")
      } else {
        element.classList.add("navigation-control-right")
      }
    }
  }, [isAllShow])

  return isControllerShow ? (
    <Button
      type="default"
      className={classNames(
        "floating-controller-btn",
        {
          "floating-controller-btn-open": isAllShow,
        },
        {
          "floating-controller-btn-close": !isAllShow,
        },
      )}
      onClick={handleClick}
    >
      <div className="btn-content-box">
        {isAllShow ? (
          <>
            <span>收起</span>
            &nbsp;
            <RightOutlined />
          </>
        ) : (
          <>
            <LeftOutlined />
            &nbsp;
            <span>展开</span>
          </>
        )}
      </div>
    </Button>
  ) : null
}

export default FloatingControllerButton
